var cifBg = ["301 181", "<g fill='none'><path fill='#FFF' d='M.5.5h300v180H.5z'/><path fill='#00966E' d='M.5 60.5h300v120H.5z'/><path fill='#D62612' d='M.5 120.5h300v60H.5z'/></g>"];

export { cifBg };

